<template>
    <div class="footer-wrapper">
        <div class="links">
<!--            <ul class="clearfix">-->
<!--                <li class="item-link"><a>关于我们</a>｜</li>-->
<!--                <li class="item-link"><a>联系我们</a>｜</li>-->
<!--                <li class="item-link"><a>招聘英才</a>｜</li>-->
<!--                <li class="item-link"><a>成功案例</a>｜</li>-->
<!--                <li class="item-link"><a>商学院</a>｜</li>-->
<!--                <li class="item-link"><a>广告服务</a>｜</li>-->
<!--                <li class="item-link"><a>商家入驻</a>｜</li>-->
<!--                <li class="item-link"><a>商会联盟</a>｜</li>-->
<!--                <li class="item-link"><a>友情链接</a>｜</li>-->
<!--                <li class="item-link"><a>网站地图</a>｜</li>-->
<!--                <li class="item-link"><a>商维宝公益</a>｜</li>-->
<!--                <li class="item-link"><a>物流宝</a>｜</li>-->
<!--                <li class="item-link"><a>商维宝讲坛</a></li>-->
<!--            </ul>-->
        </div>
        <p class="mt10 mb10"><a class="font-black" :href="icpInfo.gwAbNoLink" target="_blank">{{icpInfo.icpNo || ""}}</a></p>
        <p class="mt10 mb10">{{icpInfo.copyRight}}</p>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Routes } from '../../app.vues'

    export default {
        name: 'swb-login-foot',
        desc: '脚信息',
        props: ['name'],
        data: function () {
            return {
                icpInfo: {
                    icpNo: "苏ICP备16054140号-1",
                    gwAbNoLink: "http://www.miibeian.gov.cn",
                    copyRight: "南京商维宝科技有限公司 版权所有"
                }
            }
        },
        created: function () {
            let icpInfo = getIcpInfo();
            this.icpInfo = Utils.merge({}, icpInfo);
        },
        methods: {}
    }

</script>





// WEBPACK FOOTER //
// src/compo/user/Login-foot.vue